import { render, staticRenderFns } from "./VerifiedResearch.vue?vue&type=template&id=61f7c0a0"
import script from "./VerifiedResearch.vue?vue&type=script&lang=js"
export * from "./VerifiedResearch.vue?vue&type=script&lang=js"
import style0 from "./VerifiedResearch.vue?vue&type=style&index=0&id=61f7c0a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports